import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentDetail: null // 修改为存储单个对象
  },
  getters: {
    getCurrentDetail(state) {
      return state.currentDetail;
    }
  },
  mutations: {
    setCurrentDetail(state, detail) {
      state.currentDetail = detail;
    }
  },
  actions: {
    setCurrentDetail({ commit }, detail) {
      commit('setCurrentDetail', detail);
    }
  },
  modules: {}
})
